import { render, staticRenderFns } from "./OrderInputs.vue?vue&type=template&id=65b82782&scoped=true"
import script from "./OrderInputs.vue?vue&type=script&lang=js"
export * from "./OrderInputs.vue?vue&type=script&lang=js"
import style0 from "./OrderInputs.vue?vue&type=style&index=0&id=65b82782&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b82782",
  null
  
)

export default component.exports